import { FormikProps } from 'formik';
import * as React from 'react';
import {
  DebitDetailsSubForm,
  DebitDetailsSubFormCore,
  DebitDetailsSummary,
  DebitDetailsSummaryCore,
} from '../../components/DebitDetails/';
import { DirectDebitForm } from '../Form/Form';
import { config } from '../../config';
import FlaggedFeature from '../../utils/FlaggedFeature';

interface DebitDetailsSectionProps {
  formikProps: FormikProps<DirectDebitForm>;
  isEdit: boolean;
  isComplete: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
  onEditClick: () => void;
}

export const DebitDetailsSection: React.FC<DebitDetailsSectionProps> = ({
  formikProps,
  isEdit,
  isComplete,
  onPreviousClick,
  onNextClick,
  onEditClick,
}) => {
  const { debitDetails: debitDetailParentValues } = formikProps.values;
  const {
    electricity: parentFormElectricity,
    gas: parentFormGas,
  } = formikProps.values.connection;

  return (
    <>
      {isEdit ? (
        <FlaggedFeature
          featureFlag={config.enableCoreIntegration}
          fallback={
            <DebitDetailsSubForm
              formikProps={formikProps}
              isEdit={isEdit}
              onPreviousClick={onPreviousClick}
              onNextClick={onNextClick}
            />
          }
        >
          <DebitDetailsSubFormCore
            formikProps={formikProps}
            isEdit={isEdit}
            onPreviousClick={onPreviousClick}
            onNextClick={onNextClick}
          />
        </FlaggedFeature>
      ) : (
        <FlaggedFeature
          featureFlag={config.enableCoreIntegration}
          fallback={
            <DebitDetailsSummary
              selectedElectricity={parentFormElectricity}
              selectedGas={parentFormGas}
              debiltDetails={{
                bankAccountName: debitDetailParentValues.bankAccountName,
                bsbNumber: debitDetailParentValues.bsbNumber,
                paymentMethod: debitDetailParentValues.paymentMethod,
                bankAccountNumber: debitDetailParentValues.bankAccountNumber,
              }}
              showSummaryFields={isComplete}
              onEditClick={onEditClick}
            />
          }
        >
          <DebitDetailsSummaryCore
            selectedElectricity={parentFormElectricity}
            selectedGas={parentFormGas}
            debiltDetails={{
              bankAccountName: debitDetailParentValues.bankAccountName,
              bsbNumber: debitDetailParentValues.bsbNumber,
              paymentMethod: debitDetailParentValues.paymentMethod,
              bankAccountNumber: debitDetailParentValues.bankAccountNumber,
              creditCard: {
                // eslint-disable-next-line
                ...debitDetailParentValues.creditCard!,
                cardName: debitDetailParentValues.cardName,
                cardType: debitDetailParentValues.cardType,
              },
            }}
            showSummaryFields={isComplete}
            onEditClick={onEditClick}
          />
        </FlaggedFeature>
      )}
    </>
  );
};
